import styled from 'styled-components'

const Style = {
	Wrapper: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 40px;
		padding: 20px;
		background-color: ${({theme}) => theme.color.white};
		border-radius: 16px;

		@media (min-width: ${({theme}) => theme.breakpoints.mobile}) {
			padding: 40px;
		}
	`,

	PreviewImg: styled.img`
		width: 240px;
		height: 120px;
		object-fit: cover;
		object-position: center center;
		border-radius: 8px;
		margin: 8px 0;
	`,
	PreviewVideo: styled.video`
		width: 240px;
		height: 120px;
		object-fit: cover;
		object-position: center center;
		border-radius: 8px;
		margin: 8px 0;
	`,
	Radio: styled.button`
		display: flex;
		align-items: center;
		gap: 8px;
	`,
}

export default Style
